import React from 'react';

interface IProps {
  style?: any;
}

const EditBrandIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={props.style}>
        <path d="M13.507 7.49854L10.4154 4.40687L11.6154 3.21104C11.8528 2.98289 12.1694 2.85547 12.4987 2.85547C12.828 2.85547 13.1446 2.98289 13.382 3.21104L14.7029 4.53187C14.937 4.76625 15.0684 5.08396 15.0684 5.41521C15.0684 5.74646 14.937 6.06417 14.7029 6.29854L13.507 7.49854ZM4.75704 16.2485L12.9154 8.09021L9.8237 4.99854L0.952872 13.8694C0.914254 13.9083 0.883702 13.9545 0.862967 14.0052C0.842232 14.056 0.831721 14.1104 0.832038 14.1652V16.6652C0.832038 16.7757 0.875937 16.8817 0.954077 16.9598C1.03222 17.038 1.1382 17.0819 1.2487 17.0819H19.1654V16.2485H4.75704Z" fill="#204078"/>
    </svg>
  )
}

export default EditBrandIcon;